import React from "react";
import uPlot from "uplot";
import UplotReact from "uplot-react";

import "uplot/dist/uPlot.min.css";
import "./uplot.css";

const defaultFunc = () => {};

interface Props {
  options: uPlot.Options;
  data: uPlot.AlignedData;
  onCreate?: () => void;
  onDelete?: () => void;
}

const LineChartUplot: React.FC<Props> = ({ options, data, onCreate = defaultFunc, onDelete = defaultFunc }) => {
  return <UplotReact key="hooks-key" options={options} data={data} onDelete={onCreate} onCreate={onDelete} />;
};

export default LineChartUplot;
